import { autoinject } from 'aurelia-framework';
import { NodeModel } from '../../../models/node-model';
import { ApiService } from '../../../utils/api-service';

@autoinject
export class OrganizationalUnitService {
	treeNodes: OrganizationalNodeModel[] = [];
	refreshingNodes = true;

	constructor(private api: ApiService) {
	}

	refreshOrganizationalUnits(organizationId: string, includeIgnoredCostCenters: boolean) {
		this.refreshingNodes = true;
		this.treeNodes = [];

		return this.getOrganizationalUnits(organizationId, includeIgnoredCostCenters).then(nodes => {
			this.treeNodes = nodes;
			this.refreshingNodes = false;
		});
	}

	refreshOrganizationalUnitsForFiscalYear(fiscalYearId: string, includeIgnoredCostCenters: boolean) {
		this.refreshingNodes = true;
		this.treeNodes = [];

		return this.getOrganizationalUnitsForFiscalYear(fiscalYearId, includeIgnoredCostCenters).then(nodes => {
			this.treeNodes = nodes;
			this.refreshingNodes = false;
		});
	}

	async getOrganizationalUnits(organizationId: string, includeIgnoredCostCenters: boolean): Promise<OrganizationalNodeModel[]> {

		if (organizationId === '' || organizationId == null) { return []; }

		return this.getOrganizationalUnitsCore(`organizations/${organizationId}/organizational-units`, includeIgnoredCostCenters);
	}

	async getOrganizationalUnitsForFiscalYear(fiscalYearId: string, includeIgnoredCostCenters: boolean): Promise<OrganizationalNodeModel[]> {

		if (fiscalYearId === '' || fiscalYearId == null) { return []; }

		return this.getOrganizationalUnitsCore(`organizational-units/for-fiscalyear/${fiscalYearId}`, includeIgnoredCostCenters);
	}

	private async getOrganizationalUnitsCore(uri: string, includeIgnoredCostCenters: boolean): Promise<OrganizationalNodeModel[]> {

		let finalUri = uri;
		if (includeIgnoredCostCenters) {
			finalUri += `?includeIgnoredCostCenters=true`;
		}
		const units = await this.api.fetchJson(finalUri);
		return units.map(unit => this.createTreeNode(unit, 1, null, 1));
	}

	// todo: why do we need orderNumber here?
	private createTreeNode(
		unit: IOrganizationNodeAM,
		orderNumber: number,
		parent: NodeModel,
		level: number): OrganizationalNodeModel {

		const node = new OrganizationalNodeModel(
			unit.identifier + ' ' + unit.name,
			unit.identifier,
			unit.name,
			orderNumber,
			parent != null ? parent.title : null,
			unit.id,
			unit.activeFrom,
			unit.activeUntil);
		node.parent = parent;
		node.level = level;
		node.nodeType = unit.nodeType;
		node.isIgnored = unit.isIgnored;
		if(node.isIgnored) {
			node.toggleCssClass('ignored');
		}
		node.children = unit.children.map((child, index) => this.createTreeNode(child, index + 1, node, level + 1));
		return node;
	}
}

export interface IOrganizationNodeAM {
	id: string;
	identifier: string;
	name: string;
	nodeType: string;
	isIgnored: boolean;
	activeFrom: Date;
	activeUntil: Date;
	children: IOrganizationNodeAM[];
}

export class OrganizationalNodeModel extends NodeModel {
	identifier: string;
	name: string;
	removable: boolean;
	isIgnored: boolean;
	activeFrom: Date;
	activeUntil: Date;

	constructor(
		title: string,
		identifier: string,
		name: string,
		sortOrder: number = 1,
		parentName: string = null,
		id: string = null,
		activeFrom: Date = null,
		activeUntil: Date = null) {

		super(title, sortOrder, parentName, id, identifier);
		this.identifier = identifier;
		this.name = name;
		this.activeFrom = activeFrom;
		this.activeUntil = activeUntil;
	}
}
